<template>
  <div id="app">
    <cv-header :content="content"/>
    <cv-sub-header observe="deco" :profile="content.profile"/>
    <cv-decoration id="deco"/>
    <cv-body :content="content"/>
  </div>
</template>

<script>
import cvHeader from '@/components/Header.vue'
import cvSubHeader from '@/components/SubHeader.vue'
import cvDecoration from '@/components/Decoration.vue'
import cvBody from '@/components/Body.vue'
import content from '@/content.js'

export default {
  name: 'app',
  components: {
    cvHeader,
    cvSubHeader,
    cvDecoration,
    cvBody
  },
  data () {
    return {
      content: content
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?09ea41a7